import { lazy } from "react";

import AppIcons from "../../../components/Base/AppIcons";
import { listPermissionsModuleMovimientos } from "./listPermissionsModuleMovimientos";
const Movimientos = lazy(() => import("./views/ViewsMovimientos"));

const routesModuleMovimientos = {
  link: "/pasarela-asignacion-qr--module-movimientos",
  label: <AppIcons Logo={"RECARGA_CELULAR"} name="Asignación Por Qr" />,
  component: Movimientos,
  permission: [...listPermissionsModuleMovimientos],
  subRoutes: [],
  show: true,
};

export default routesModuleMovimientos;
